/**
 * Which `project:` block a git workspace's manifest gets on this device
 * (card 2.2). Its own module so the git writers (gitFlush, gitWorkspaceStore)
 * depend on the scope store only, never on the records / auth layers.
 */
import { useProjectScopeStore } from './projectScopeStore';
import { projectFromManifest } from './projectManifestText';
import { holdsWorkspace } from './projectBindingFields';

/** The block to write for `workspaceId`: the project bound to it on this device, or null. */
export function projectBlockFor(workspaceId, projects = useProjectScopeStore.getState().known.projects) {
  if (workspaceId == null) return null;
  const p = (projects || []).find((x) => x && holdsWorkspace(x, workspaceId));
  return p ? projectFromManifest({ id: p.id, name: p.name, color: typeof p.color === 'string' ? p.color : null }) : null;
}

